<template>
  <section>
    <!-- HEADER -->
    <div class="card">
      <div class="card-content">
        <div class="columns is-mobile">
          <div class="column">
            <p @click="back()" class="back-btn title is-6" style="margin-bottom: 10px;"> <b-icon icon='arrow-left'/> Kembali ke produk</p>
            <h1 style="padding-left: 10px;" class="title is-4">Detail Produk</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- DETAIL -->
    <div v-if="product !== null" class="box">
      <h1 class="title is-5">Info Produk</h1>
      <article class="media">
        <div class="media-left">
          <figure class="image is-128x128">
            <img :src="product.image_uri" style="max-width: 100px; border-radius: 20px;" />
          </figure>
        </div>
        <div class="media-content">
          <div class="content">
            <p><strong>{{ product.name }}</strong></p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <div class="level-item">
                <b-button @click="ubahProdukOnClick()" type="is-success">Ubah</b-button>
              </div>
              <div class="level-item">
                <b-button @click="deleteProduct()" type="is-danger" icon-left="delete">Hapus</b-button>
              </div>
            </div>
          </nav>
        </div>
      </article>
    </div>

    <!-- EDIT PRODUK -->
    <b-modal
      v-model="editProdukIsShow"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      :can-cancel="false">
      <form action="">
        <div class="modal-card" style="width: 500px; height: 600px;">
          <header class="modal-card-head">
            <p class="modal-card-title">Edit Info</p>
            <button
              type="button"
              class="delete"
              @click="editProdukIsShow = false"/>
          </header>
          <section class="modal-card-body">
            <b-field label="Nama Produk">
              <b-input
                v-model="produk.name"
                placeholder="Masukan nama produk disini"
                required>
              </b-input>
            </b-field>
            <b-field label="Foto Produk">
              <b-input
                v-model="produk.image_uri"
                placeholder="Masukan URL foto produk disini"
                required>
              </b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <b-button
              :loading="isLoading"
              @click="saveUbahProduk()"
              label="Simpan"
              type="is-success" />
          </footer>
        </div>
      </form>
    </b-modal>

  </section>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import { mapGetters } from 'vuex'
// import Multiselect from 'vue-multiselect'

export default {
  name: 'PengaturanProductDetail',
  data () {
    return {
      product: null,
      tambahIsShow: false,
      isEdit: false,
      editProdukIsShow: false,
      produk: {
        name: null,
        image_uri: null
      },
      penugasanTukang: [],
      penugasanTukangSelected: [],
      name: null,
      isLoading: false,
      price0: 0,
      price1: 0,
      price2: 0,
      layananSelected: null
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl'
    })
  },
  components: {},
  methods: {
    back () {
      this.$router.push({ path: '/pengaturan' })
    },
    addTag (val) {
      this.penugasanTukangSelected.push(val)
    },
    async loadData (productId) {
      await axios.get(`${this.url}/api/v1/vendor/product_detail?product_id=${productId}`)
        .then((cb) => {
          if (cb.data.code === 1) {
            this.product = cb.data.data
          }
        })
    },
    clearData () {
      this.name = null
      this.penugasanTukangSelected = []
      this.isEdit = false
      this.price0 = 0
      this.price1 = 0
      this.price2 = 0

      this.produk = {
        name: null,
        image_uri: null
      }
    },
    editLayanan (layanan) {
      this.layananSelected = layanan
      this.setEditService(layanan)
      this.tambahIsShow = true
    },
    deleteProduct () {
      this.$buefy.dialog.confirm({
        message: 'Hapus produk : ' + this.product.name,
        onConfirm: () => {
          axios.delete(`${this.url}/api/v1/vendor/product`, {
            data: {
              product_id: this.product.id
            }
          })
            .then(() => {
              this.$buefy.toast.open({
                duration: 5000,
                message: 'Hapus Produk berhasil!...',
                position: 'is-bottom',
                type: 'is-success'
              })
              this.back()
            })
            .catch(() => {
              this.$buefy.toast.open({
                duration: 5000,
                message: 'Error hapus layanan',
                position: 'is-bottom',
                type: 'is-danger'
              })
            })
        }
      })
    },
    setEditService (val) {
      this.isEdit = true
      this.name = val.name
      _.forEach(val.price, (row) => {
        if (row.sesi === 0) {
          this.price0 = row.price
        }
        if (row.sesi === 1) {
          this.price1 = row.price
        }
        if (row.sesi === 2) {
          this.price2 = row.price
        }
      })
      this.penugasanTukangSelected = val.skill_list
    },
    setFormat (v) {
      return moment(v).format('DD MMMM YYYY')
    },
    ubahProdukOnClick () {
      this.produk.name = this.product.name
      this.produk.image_uri = this.product.image_uri
      this.editProdukIsShow = true
    },
    saveUbahProduk () {
      if (this.produk.name === null || this.produk.image_uri === null) {
        return
      }
      this.isLoading = true
      const data = {
        product_id: this.product.id,
        product_name: this.produk.name,
        product_image: this.produk.image_uri
      }
      axios.put(`${this.url}/api/v1/vendor/product`, data)
        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: 'Simpan data berhasil!...',
            position: 'is-bottom',
            type: 'is-info'
          })
          this.clearData()
          this.loadData(this.product.id)
          this.editProdukIsShow = false
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$buefy.toast.open({
            duration: 5000,
            message: 'Error load skill lists',
            position: 'is-bottom',
            type: 'is-danger'
          })
        })
    }
  },
  mounted () {},
  created () {
    this.loadData(this.$route.params.productId)
  }
}
</script>

<style lang="scss" scoped>
tr:nth-child(even) {
  background-color: #f2f2f2;
}
td {
  padding: 10px;
}

.clickable {
  cursor: pointer;
}
.dash-container {
  padding: 20px 0px 0px 0px;
}
.card-kanggo {
  background-color: white;
  margin: 0px 10px 10px 10px;
  border-radius: 5px;
  padding: 5px 0px 5px 0px;
  font-size: 14px;
  table {
    tr {
      td {
        width: auto;
        border-bottom: solid thin rgb(240, 240, 240);
        height: 45px;
        padding: 10px 15px 5px 15px;
      }
    }
  }
}
.card-paginate {
  display: flex;
  font-size: 14px;
}
.tab-label {
  width: 150px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  cursor: pointer;
  &.active {
    border-bottom: solid thin red;
    color: red;
    font-weight: bold;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
